import styled from 'styled-components';
import { animated } from 'react-spring';
import { themeGet } from 'styled-system';
import { theme } from '../../theme';

export const Container = styled('div')`
  left: 30px;
  right: 30px;
  width: 0 auto;
  display: flex;
  z-index: ${theme.zIndex[14]};
  margin: 0 auto;
  position: fixed;
  border-radius: 4px;
  align-items: center;
  pointer-events: none;
  justify-content: center;
  top: ${(props: any) => (props.top ? '30px' : 'unset')};
  bottom: ${(props: any) => (props.top ? 'unset' : '20px')};
  flex-direction: ${(props: any) => (props.top ? 'column-reverse' : 'column')};
  align-items: ${(props: any) => (props.position === 'center' ? 'center' : `flex-${props.position || 'end'}`)};
  @media (max-width: 680px) {
    align-items: center;
  }
`;

export const Message = styled(animated.div)`
  width: auto;
  max-width: 50ch;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin-bottom: ${(props: any) => (!props.top ? '10px' : '0')};
  @media (max-width: 680px) {
    width: 100%;
  }
`;

export const Content = styled('div')<any>`
  color: white;
  display: flex;
  font-size: 1em;
  overflow: hidden;
  padding: 25px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  background: ${(props: any) =>
    props.intent === 'SUCCESS' ? themeGet('colors.success', '#445159') : themeGet('colors.error', '#445159')};
`;

export const Button = styled('button')`
  top: 5px;
  margin: 0;
  outline: 0;
  right: 5px;
  padding: 0;
  border: none;
  display: flex;
  cursor: pointer;
  overflow: hidden;
  position: absolute;
  pointer-events: all;
  align-self: flex-end;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  :hover {
    color: rgba(255, 255, 255, 1);
  }
`;

export const Life = styled(animated.div)`
  left: 0px;
  height: 5px;
  width: auto;
  background: #fff;
  position: absolute;
  border-bottom-left-radius: 4px;
  bottom: ${(props: any) => (props.top ? '10px' : '0')};
`;



// WEBPACK FOOTER //
// ./src/components/toasts/StyledElements.tsx